module.exports = __webpack_public_path__ + "img/pauseIcon.233d2bad.png";